import * as firebase from 'firebase/app';
import Helpers from '../helpers/shared.helper';
import Settings from './settings.service';
import Storage from "./storage.service";

// Analytics For Kuwait & KSA
var FirebaseAnalytics = {};

FirebaseAnalytics.onload = () => {
    let uid = Storage.get("uid", true);
    const fireObj = {
        device_id: Storage.get("device_id", true),
        session: Storage.get("session", true),
        platform: "web",
        lang: Helpers.getCookie("lang"),
        environment: Settings.environment,
        uid: uid,
        build_no: 1,
        product_category: "regular"
    }
    firebase.analytics().setUserProperties(fireObj);
    if (uid) {
        firebase.analytics().setUserProperties({ uid: uid });
    }
}

FirebaseAnalytics.init = () => {
    if (Settings?.firebase_enabled && !firebase.apps.length) {
        try {
            firebase.initializeApp(Settings?.firebase_analytics_configs);
            FirebaseAnalytics.onload();
        } catch(error) {
            console.log("Error in Analytics", error)
        }
    }
}

// Set User if Any Property Changes
FirebaseAnalytics.updateUser = (eventParams = {}) => {
    if (Settings?.firebase_enabled) {
        try {
            firebase.analytics().setUserProperties(eventParams);
        } catch(error) {
            console.log("Error in Analytics", error)
        }
    }
}

/**
 * Language Updated
 */
FirebaseAnalytics.preferred_lang_updated = (lang) => {
    if (Settings?.firebase_enabled) {
        try {
            firebase.analytics().setUserProperties({ lang: lang, });
        } catch(error) {
            console.log("Error in Analytics", error)
        }
    }
}

/**
 * Log Event Fot the Analytics with event and params
 * @param eventName
 * @param eventParams
 * @param options
 */
FirebaseAnalytics.logEvent = (eventName, eventParams = {}, options = false) => {
    if (Settings?.firebase_enabled) {
        try {
            firebase.analytics().logEvent(eventName, eventParams, options);
        } catch(error) {
            console.log("Error in Analytics", error)
        }
    }
};

FirebaseAnalytics.number_selected = (param) => {
    FirebaseAnalytics.logEvent('number_selected', param);
}

FirebaseAnalytics.plan_selected = (param) => {
    FirebaseAnalytics.logEvent('plan_selected', param);
    FirebaseAnalytics.logEvent('storefront_plan_selected', param);
}

FirebaseAnalytics.storefront_plan_selected = (param) => {
    FirebaseAnalytics.logEvent('plan_selected', param);
    FirebaseAnalytics.logEvent('storefront_plan_selected', param);
}

FirebaseAnalytics.additional_offer_added = (param) => {
    FirebaseAnalytics.logEvent('additional_offer_added', param);
}

FirebaseAnalytics.offer_removed = () => {
    FirebaseAnalytics.logEvent('offer_removed');
}

FirebaseAnalytics.offer_applied = (param) => {
    FirebaseAnalytics.logEvent('offer_applied', param);
}

FirebaseAnalytics.create_account_success = (param) => {
    FirebaseAnalytics.logEvent('create_account_success', param);
}

FirebaseAnalytics.search_executed = (param) => {
    FirebaseAnalytics.logEvent('search_executed', param);
}

FirebaseAnalytics.vanityDetail = (param) => {
    FirebaseAnalytics.logEvent('vanity', param);
}

FirebaseAnalytics.create_account_check = (param) => {
    FirebaseAnalytics.logEvent('create_account_check', param);
}

FirebaseAnalytics.create_account_pass = (param) => {
    FirebaseAnalytics.logEvent('create_account_pass', param);
}

FirebaseAnalytics.begin_checkout = (param) => {
    FirebaseAnalytics.logEvent('begin_checkout', param);
}

FirebaseAnalytics.ecommerce_purchase = (param) => {
    FirebaseAnalytics.logEvent('ecommerce_purchase', param);
}

FirebaseAnalytics.delivery_request = () => {
    FirebaseAnalytics.logEvent('delivery_request');
}

FirebaseAnalytics.delivery_qr_viewed = () => {
    FirebaseAnalytics.logEvent('delivery_qr_viewed');
}

FirebaseAnalytics.sim_activated = (param) => {
    FirebaseAnalytics.logEvent('sim_activated', param);
}

FirebaseAnalytics.sim_activation_failed = () => {
    FirebaseAnalytics.logEvent('sim_activation_failed');
}

FirebaseAnalytics.sim_scanned = (param) => {
    FirebaseAnalytics.logEvent('sim_scanned', param);
}

FirebaseAnalytics.plan_change_requested = (param) => {
    FirebaseAnalytics.logEvent('plan_change_requested', param);
}

FirebaseAnalytics.error_ocurred = (param) => {
    if (param?.screen_name === "confirmation") {
        FirebaseAnalytics.logEvent('payment_error', param);
    } else {
        FirebaseAnalytics.logEvent('error_ocurred', param);
    }
}

FirebaseAnalytics.button_clicked = (screen = "screen", btnText) => {
    let screenName = Storage.get('Page_name') || screen;
    let btnDefault = {
        item_id: screenName && btnText ? `${screenName}_${btnText}_btn` : "",
        screen_name: screenName,
        item_text: btnText ? btnText : ""
    }
    FirebaseAnalytics.logEvent('button_clicked', btnDefault);
}

FirebaseAnalytics.payment_error = (param) => {
    FirebaseAnalytics.logEvent('payment_error', param);
}

FirebaseAnalytics.delivery_delivered = (param) => {
    FirebaseAnalytics.logEvent('delivery_delivered', param);
}

FirebaseAnalytics.authentication_success = () => {
    FirebaseAnalytics.logEvent('authentication_success');
}

FirebaseAnalytics.about_modal_info = (cta, param) => {
    // Used for "about_optima_info"
    // @param: screen - storefront/plan_selection
    FirebaseAnalytics.logEvent(`${cta}_info`, param);
}

FirebaseAnalytics.about_credit_score_info = () => {
    FirebaseAnalytics.logEvent('about_credit_score_info');
}

FirebaseAnalytics.about_advance_payment_info = () => {
    FirebaseAnalytics.logEvent('about_advance_payment_info');
}

FirebaseAnalytics.about_deposit_payment_info = () => {
    FirebaseAnalytics.logEvent('about_deposit_payment_info');
}

FirebaseAnalytics.about_credit_limit_info = () => {
    FirebaseAnalytics.logEvent('about_credit_limit_info');
}

FirebaseAnalytics.storefront_cta_selected = (cta) => {
    let param = {
        storefront_cta_selected: cta,
    }
    FirebaseAnalytics.logEvent('storefront_cta_selected', param);
}

FirebaseAnalytics.generic_event = (code) => {
    let codeValue = "";
    switch (code) {
        case 1:
            codeValue = "SELF_CARE-Sim Deactivation-Post paid suggestion";
            break;
        case 2:
            codeValue = "SELF_CARE-Sim Deactivation-SIM deactivation closing bill";
            break;
        case 3:
            // Not in use
            codeValue = "SELF_CARE-Sim Deactivation-SIM deactivation flow completed";
            break;
        case 4:
            // Not in use
            codeValue = "SELF_CARE-Sim Deactivation-Restore SIM deactivation";
            break;
        case 5:
            codeValue = "SELF_CARE-Sim Deactivation-Deactivate SIM";
            break;
        case 6:
            codeValue = "SELF_CARE-Sim Deactivation-deactivation_started";
            break;
        case 7:
            codeValue = "SELF_CARE-Sim Deactivation-sim_deactivated";
            break;
        case 8:
            // Not in Web
            codeValue = "SELF_CARE-Sim Deactivation-change_plan_started_from_deactivation";
            break;
        case 9:
            codeValue = "SELF_CARE-Sim Deactivation-deactivate_sim_without_payment";
            break;
        case 10:
            codeValue = "SELF_CARE-Sim Deactivation-deactivate_sim_with_payment";
            break;
        case 11:
            // Not in Web
            codeValue = "SELF_CARE-Sim Deactivation-download_bill";
            break;
        // Bill Payment Screens
        case 12:
            codeValue = "SELF_CARE-Bill Summary-Bill Payment";
            break;
        case 13:
            codeValue = "SELF_CARE-Bill Summary-Bill Summary Details";
            break;
        case 14:
            codeValue = "SELF_CARE-Bill Summary-Bill List";
            break;
        case 15:
            codeValue = "SELF_CARE-Bill Summary-Bill Payment Success";
            break;
        case 16:
            codeValue = "SELF_CARE-Bill Summary-Bill Payment Failure";
            break;
        default:
            break;
    }
    const firebaseParam = {
        screen_name: codeValue,
    }
    FirebaseAnalytics.logEvent("screen_view", firebaseParam);
}

FirebaseAnalytics.download_bill = (param) => {
    FirebaseAnalytics.logEvent('download_bill', param);
}

FirebaseAnalytics.pay_bill = (param) => {
    // payment_status, amount , currency, tax, item_category (advance/ bill)
    FirebaseAnalytics.logEvent('pay_bill', param);
}

FirebaseAnalytics.summary_package_card = (param) => {
    FirebaseAnalytics.logEvent('summary_package_card', param);
}

FirebaseAnalytics.quick_service = (param) => {
    // type - PayBills, QuickTopup, EAuction, ProtectionChannel, SimDeactivation, Advertisement
    FirebaseAnalytics.logEvent('quick_service', param);
}

FirebaseAnalytics.closing_pay_bill = (param) => {
    // item_category - closing_bill
    // bill_status -1 (success) / 0 (failed)
    // tax
    // bill_amount
    // currency
    FirebaseAnalytics.logEvent('pay_bill', param);
}

FirebaseAnalytics.sim_deactivated = (param) => {
    //reason_id
    FirebaseAnalytics.logEvent('sim_deactivated', param);
}

FirebaseAnalytics.basicEvent = (code) => {
    let codeValue = "";
    switch (code) {
        case 1:
            codeValue = "SELF_CARE-Sim Deactivation-Post paid suggestion";
            break;
        case 2:
            codeValue = "SELF_CARE-Sim Deactivation-SIM deactivation closing bill";
            break;
        case 3:
            codeValue = "SELF_CARE-Sim Deactivation-SIM deactivation flow completed";
            break;
        case 4:
            // Not in use
            codeValue = "SELF_CARE-Sim Deactivation-Restore SIM deactivation";
            break;
        case 5:
            codeValue = "SELF_CARE-Sim Deactivation-Deactivate SIM";
            break;
        case 6:
            codeValue = "deactivation_started";
            break;
        case 7:
            codeValue = "SELF_CARE-Sim Deactivation-sim_deactivated";
            break;
        case 8:
            // Not in Web
            codeValue = "change_plan_started_from_deactivation";
            break;
        case 9:
            codeValue = "deactivate_sim_without_payment";
            break;
        case 10:
            codeValue = "deactivate_sim_with_payment";
            break;
        case 11:
            // Not in Web
            codeValue = "SELF_CARE-Sim Deactivation-download_bill";
            break;
        default:
            break;
    }
    FirebaseAnalytics.logEvent(codeValue);
}

FirebaseAnalytics.sim_activation_started = (param) => {
    FirebaseAnalytics.logEvent('sim_activation_started', param);
}

export default FirebaseAnalytics;